import { useEffect } from "react";
import {} from "../../core/feature/store";

import { BrowserView, MobileView } from "react-device-detect";
import ReactGA from "react-ga4";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import LoginMobile from "./loginMobile";
import LoginWeb from "./loginWeb";
const Login = () => {
  const gaEventTracker = useAnalyticsEventTracker("Log In");

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Log In",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <LoginWeb></LoginWeb>
      </BrowserView>
      <MobileView>
        <LoginMobile></LoginMobile>
      </MobileView>
    </>
  );
};

export default Login;
